import "./datatable.scss";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { lformColumns, lformRows, fetchLformRows } from "../../datatablesource";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSlug } from "../../SlugContext";
import { serverUrl } from "../../temp";
import Loader from "../loader/Loader";

const LateFormDataTable = () => {
  const [data, setData] = useState(lformRows);
  const [loading, setLoading] = useState(false);
  const studentName = localStorage.getItem("student_name");

  const { slugs } = useSlug();
  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const rows = await fetchLformRows();
      console.log("jawad", rows);
      setLoading(false);
      setData(Array.from(rows.data));
    };
    getData();
  }, []);

  const handleDelete = (id) => {
    // Make a DELETE request to the Flask API endpoint
    fetch(`${serverUrl}/student/del_lform/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        // Remove the item from your React data state if the API request is successful
        setData(data.filter((item) => item.id !== id));
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  const viewLinkString = "Lateform-Single";
  const editLinkString = "Lateform-Edit";
  const newLinkString = "Lateform-New";

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {slugs && slugs.includes(viewLinkString) && (
              <Link
                to={`/student-attendance/late-form/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="viewButton">View</div>
              </Link>
            )}
            {slugs && slugs.includes(editLinkString) && (
              <Link
                to={`/student-attendance/late-form/update-late-form/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="editButton">Edit</div>
              </Link>
            )}
            <div
              className="deleteButton disabled"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="datatable">
      <div className="datatableTitle flex justify-between flex-wrap w-full lg:no-flexwrap gap-2  pb-5 lg:pb-10">
        <span> {studentName}'s Late Form</span>
        <div className="linkGroup flex justify-end w-full gap-2 lg:w-fit items-center lg:gap-2 flex-wrap lg:no-flexwrap">
          {slugs && slugs.includes(newLinkString) && (
            <Link
              to="/student-attendance/late-form/new"
              className="commonButton w-full sm:w-auto"
            >
              Add New
            </Link>
          )}{" "}
          <Link
            to="/student-attendance"
            className="commonButton w-full sm:w-auto"
          >
            Back
          </Link>
        </div>
      </div>
      {loading ? (
        // <h1 style={{ textAlign: "student-attendance", paddingTop: "20%" }}>
        //   loading...
        // </h1>
        <Loader fullScreen={false} />
      ) : (
        <DataGrid
          className="datagrid"
          rows={data}
          columns={lformColumns.concat(actionColumn)}
          pageSize={9}
          rowsPerPageOptions={[9]}
          components={{
            Toolbar: GridToolbar, // Include the GridToolbar in the Toolbar slot
          }}
        />
      )}
    </div>
  );
};

export default LateFormDataTable;
